'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiDevicePhone = function TiDevicePhone(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 5h-11.7c-2.7 0-5 2.2-5 5v20c0 2.8 2.3 5 5 5h11.7c2.8 0 5-2.2 5-5v-20c0-2.8-2.2-5-5-5z m1.7 25c0 0.9-0.8 1.7-1.7 1.7h-11.7c-0.9 0-1.6-0.8-1.6-1.7v-20c0-0.9 0.7-1.7 1.6-1.7h11.7c0.9 0 1.7 0.8 1.7 1.7v20z m-3.4-20h-8.3c-0.9 0-1.7 0.8-1.7 1.7v15c0 0.9 0.8 1.6 1.7 1.6h2.5c0 1 0.7 1.7 1.7 1.7s1.6-0.7 1.6-1.7h2.5c1 0 1.7-0.7 1.7-1.6v-15c0-0.9-0.7-1.7-1.7-1.7z m0 16.7h-8.3v-15h8.3v15z' })
        )
    );
};

exports.default = TiDevicePhone;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/device-phone.js
// module id = 2033
// module chunks = 0